"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9829],{

/***/ 34339:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ h; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70917);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55287);




const l = _emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4`
    100% {
        transform: rotate(360deg);
    }
    `, m = (e) => _emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv`
    border-left-color: ${e || "inherit"};
    border-top-color: ${e || "inherit"};
`, f = (e) => {
  const o = typeof e == "number" ? e + "px" : e;
  return _emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv`
        width: ${o};
        height: ${o};
    `;
}, i = {
  container: _emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv`
        align-items: center;
        display: flex;
        height: 100%;
        justify-content: center;
        width: 100%;
    `,
  spinner: _emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv`
        animation: ${l} 0.5s linear 0s infinite normal both running;
        background: transparent;
        border-color: transparent;
        border-radius: 100%;
        border-style: solid;
    `,
  hiddenText: _emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv`
        visibility: hidden;
    `
}, h = ({ children: e, color: o, size: s, ...p }) => /* @__PURE__ */ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("span", { css: i.container, ...p, children: [
  /* @__PURE__ */ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(
    "span",
    {
      css: [
        i.spinner,
        m(o),
        f(s),
        e ? _emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv`
                          position: absolute;
                      ` : _emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv`
                          position: static;
                      `
      ]
    }
  ),
  e && /* @__PURE__ */ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("span", { css: i.hiddenText, children: [
    e,
    " "
  ] })
] });
h.propTypes = {
  size: prop_types__WEBPACK_IMPORTED_MODULE_2__.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2__.string, prop_types__WEBPACK_IMPORTED_MODULE_2__.number]).isRequired,
  color: prop_types__WEBPACK_IMPORTED_MODULE_2__.oneOf(Object.values(_constants_mjs__WEBPACK_IMPORTED_MODULE_3__/* .COLORS */ .DM)),
  children: prop_types__WEBPACK_IMPORTED_MODULE_2__.node,
  className: prop_types__WEBPACK_IMPORTED_MODULE_2__.string
};



/***/ }),

/***/ 64145:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Bs": function() { return /* binding */ b; },
  "KY": function() { return /* binding */ q; },
  "uT": function() { return /* binding */ $; },
  "ZS": function() { return /* binding */ W; },
  "SO": function() { return /* binding */ x; },
  "iP": function() { return /* binding */ N; }
});

// UNUSED EXPORTS: useArrowKeysX, useDragX

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/throttle-debounce/esm/index.js
/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */
function throttle (delay, callback, options) {
  var _ref = options || {},
      _ref$noTrailing = _ref.noTrailing,
      noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing,
      _ref$noLeading = _ref.noLeading,
      noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading,
      _ref$debounceMode = _ref.debounceMode,
      debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */


  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel(options) {
    var _ref2 = options || {},
        _ref2$upcomingOnly = _ref2.upcomingOnly,
        upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;

    clearExistingTimeout();
    cancelled = !upcomingOnly;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (!noLeading && debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      if (noLeading) {
        /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */
        lastExec = Date.now();

        if (!noTrailing) {
          timeoutID = setTimeout(debounceMode ? clear : exec, delay);
        }
      } else {
        /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */
        exec();
      }
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */

function debounce (delay, callback, options) {
  var _ref = options || {},
      _ref$atBegin = _ref.atBegin,
      atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;

  return throttle(delay, callback, {
    debounceMode: atBegin !== false
  });
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/util.mjs
var util = __webpack_require__(27558);
;// CONCATENATED MODULE: ./node_modules/@epidemicsound/design-system/dist/hooks.mjs




const N = (e = 150) => {
  const [n, t] = (0,react.useState)(
    (0,util/* canUseDOM */.Nq)() ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: void 0,
      height: void 0
    }
  );
  return (0,react.useEffect)(() => {
    if (!(0,util/* canUseDOM */.Nq)())
      return;
    const r = throttle(e, () => {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    });
    return window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, [e]), n;
}, b = () => {
  const [e, n] = (0,react.useState)({}), [t, r] = (0,react.useState)(null), o = (0,react.useCallback)((i) => r(i), []);
  return (0,react.useLayoutEffect)(() => {
    window.requestAnimationFrame(() => n((0,util/* getBoundingClientRect */.L6)(t)));
  }, [t]), (0,react.useEffect)(() => {
    const i = () => n((0,util/* getBoundingClientRect */.L6)(t));
    return window.addEventListener("resize", i), () => window.removeEventListener("resize", i);
  }, [t]), [o, e];
};
function q(e) {
  const n = (0,react.useRef)(null);
  return (0,react.useImperativeHandle)(e, () => n.current), n;
}
const x = (e, n) => (0,react.useRef)(e || (0,util/* uniqueId */.EL)(n ? n.replace(/\s/g, "-") : "")).current;
function H(e, n, t) {
  const r = n || (0,util/* uniqueId */.EL)(t ? t.replace(/\s/g, "-") : "");
  return e.reduce(
    (o, i) => ({
      ...o,
      [i]: `${r}-${i}`
    }),
    { id: r }
  );
}
function W(e, n, t) {
  return (0,react.useRef)(H(e, n, t)).current;
}
function $(e) {
  const [n, t] = react.useState(!1);
  return { hideFocus: n, onBlur: (s) => {
    var u;
    t(!1), (u = e == null ? void 0 : e.onBlur) == null || u.call(e, s);
  }, onKeyDown: (s) => {
    var u;
    t(!1), (u = e == null ? void 0 : e.onKeyDown) == null || u.call(e, s);
  }, onMouseDown: (s) => {
    var u;
    t(!0), (u = e == null ? void 0 : e.onMouseDown) == null || u.call(e, s);
  } };
}
const P = ({ value: e, onChange: n, onStart: t, onEnd: r }) => {
  const [o, i] = d(!1), s = w(!1), u = w(0), v = w(0), C = l(n), g = l(t), p = l(r), I = (m) => {
    m.preventDefault(), s.current = !0;
    const L = f(0, 1, e), { width: R, left: y } = m.currentTarget.getBoundingClientRect();
    u.current = R, v.current = y - (y - m.clientX) - R * L, i(!0), g == null || g(L);
  }, c = D((m) => {
    s.current && (s.current = !1, p == null || p(f(0, 1, (m.clientX - v.current) / u.current))), i(!1);
  }, []), a = D((m) => {
    C(f(0, 1, (m.x - v.current) / u.current));
  }, []);
  return E(() => (o ? (document.addEventListener("mouseup", c), document.addEventListener("mousemove", a), document.addEventListener("mouseleave", c)) : (document.removeEventListener("mouseup", c), document.removeEventListener("mousemove", a), document.removeEventListener("mouseleave", c)), () => {
    document.removeEventListener("mouseup", c), document.removeEventListener("mousemove", a), document.removeEventListener("mouseleave", c);
  }), [o]), { onMouseDown: I, onMouseUp: c, isDragging: o };
}, T = (e, n) => (t) => {
  if (!["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"].includes(t.key))
    return;
  t.preventDefault(), t.stopPropagation();
  const r = t.key === "ArrowRight" || t.key === "ArrowUp" ? 0.05 : -0.05;
  let o = 1;
  t.altKey ? o = 0.2 : t.shiftKey ? o = 4 : t.metaKey && (o = 8), n(f(0, 1, e + r * o));
};



/***/ }),

/***/ 44466:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ e; }
/* harmony export */ });
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70917);

const e = _emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv`
    outline: none;
    &::-moz-focus-inner {
        border: 0;
    }
`;



/***/ }),

/***/ 27558:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EL": function() { return /* binding */ M; },
/* harmony export */   "L6": function() { return /* binding */ m; },
/* harmony export */   "Nq": function() { return /* binding */ S; },
/* harmony export */   "QU": function() { return /* binding */ b; },
/* harmony export */   "XQ": function() { return /* binding */ f; },
/* harmony export */   "ZT": function() { return /* binding */ C; },
/* harmony export */   "_2": function() { return /* binding */ y; },
/* harmony export */   "qk": function() { return /* binding */ p; }
/* harmony export */ });
/* unused harmony exports clamp, forIOS, formatSecondsToMinutesAndSeconds, formatSecondsToMinutesAndSecondsVerbose */

function f(n) {
  if (n.screenX !== 0 || n.screenY !== 0) {
    n.preventDefault();
    const t = n.target;
    t.blur(), t.parentNode && t.parentNode.blur();
  }
}
function p(n, t) {
  return function(o) {
    t && o.stopPropagation(), f(o), n && n(o);
  };
}
const h = (n) => {
  const t = Math.floor(n), o = Math.floor(n / 60), e = t - o * 60, i = e < 10 ? "0" + e : e;
  return `${o}:${i}`;
};
function g(n) {
  const t = n % 60, o = (n - t) / 60;
  return (o > 0 ? o + " minute" : "") + (o > 1 ? "s" : "") + (t > 0 && o > 0 ? " and " : "") + (t > 0 ? t + " second" : "") + (t > 1 ? "s" : "");
}
function w(n, t) {
  if (n && n.platform && ["iPad", "iPhone"].includes(n.platform))
    return t;
}
function m(n) {
  if (!n)
    return {};
  const { top: t, right: o, bottom: e, left: i, width: c, height: r, x: u, y: d } = n.getBoundingClientRect();
  return { top: t, right: o, bottom: e, left: i, width: c, height: r, x: u, y: d };
}
function y(n) {
  if (!n)
    return {};
  const t = n.getBoundingClientRect();
  let { top: o, y: e } = t;
  const { right: i, bottom: c, left: r, width: u, height: d, x: s } = t;
  return o += window.scrollY, e += window.scrollY, { top: o, right: i, bottom: c, left: r, width: u, height: d, x: s, y: e };
}
function S() {
  return typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
}
function b(n) {
  return function(o) {
    if (o.type === "keydown" && ["Enter", " "].includes(o.key))
      return n(o);
  };
}
const C = () => {
};
let l = 0;
const M = (n = "") => `${n}${l++}`, B = (n, t, o) => Math.max(n, Math.min(t, o));



/***/ }),

/***/ 61205:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button_x; },
  "Z": function() { return /* binding */ O; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Spinner/Spinner.mjs
var Spinner = __webpack_require__(34339);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/hooks.mjs + 1 modules
var hooks = __webpack_require__(64145);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/theme.mjs
var theme = __webpack_require__(67717);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/constants.mjs
var constants = __webpack_require__(55287);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/mixins.mjs
var mixins = __webpack_require__(44466);
;// CONCATENATED MODULE: ./node_modules/@epidemicsound/design-system/dist/v2/Actions/Button/buttonStyles.mjs



const l = emotion_react_browser_esm/* css */.iv`
    text-decoration: none;

    box-sizing: border-box;

    ${mixins/* noDefaultFocusMixin */.C}

    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    word-break: break-word;
    hyphens: auto;

    min-height: 2.75rem;
    min-width: 4.75rem;

    padding: 0.25rem 1rem;

    border: 0px;
    border-radius: ${constants/* RADIUS.SMALL */.OU.SMALL};

    cursor: pointer;

    font-size: 1rem;
    line-height: 1.125rem;
    font-family: ${constants/* FONTS.PRIMARY */.g5.PRIMARY};
    font-weight: 600;

    color: var(--button-text-color);
    background: var(--button-background-color);
    :hover {
        background: var(--button-background-hover-color);
    }
    :active {
        background: var(--button-background-active-color);
    }

    &[aria-disabled='true'] {
        cursor: not-allowed;
        color: var(--button-disabled-text-color);
        background: var(--button-disabled-background-color);
    }

    > * {
        flex-shrink: 0;
    }
`, d = emotion_react_browser_esm/* css */.iv`
    width: 100%;
`, i = emotion_react_browser_esm/* css */.iv`
    :focus {
        outline: 2px solid var(--button-focus-color);
        outline-offset: 2px;
    }
`, g = emotion_react_browser_esm/* css */.iv`
    color: transparent;
    cursor: wait;
`, x = emotion_react_browser_esm/* css */.iv`
    position: absolute;
    color: var(--button-text-color);
`, r = {
  dark: {
    accent: emotion_react_browser_esm/* css */.iv`
            --button-text-color: #ffffff;
            --button-background-color: #3959ff;
            --button-background-hover-color: #3552e7;
            --button-background-active-color: #314acf;
        `,
    primary: emotion_react_browser_esm/* css */.iv`
            --button-text-color: #0f0f0f;
            --button-background-color: #ffffff;
            --button-background-hover-color: #e7e7e7;
            --button-background-active-color: #cfcfcf;
        `,
    secondary: emotion_react_browser_esm/* css */.iv`
            --button-text-color: #ffffff;
            --button-background-color: rgba(255, 255, 255, 0.07);
            --button-background-hover-color: rgba(255, 255, 255, 0.12);
            --button-background-active-color: rgba(255, 255, 255, 0.21);
        `,
    destructive: emotion_react_browser_esm/* css */.iv`
            --button-text-color: #0f0f0f;
            --button-background-color: #ff5c5c;
            --button-background-hover-color: #e75555;
            --button-background-active-color: #cf4d4d;
        `,
    base: emotion_react_browser_esm/* css */.iv`
            --button-focus-color: #ffffff;
            --button-disabled-text-color: rgba(255, 255, 255, 0.21);
            --button-disabled-background-color: rgba(255, 255, 255, 0.07);
        `
  },
  light: {
    accent: emotion_react_browser_esm/* css */.iv`
            --button-text-color: #ffffff;
            --button-background-color: #274afe;
            --button-background-hover-color: #2342e5;
            --button-background-active-color: #1f3bcb;
        `,
    primary: emotion_react_browser_esm/* css */.iv`
            --button-text-color: #ffffff;
            --button-background-color: #0f0f0f;
            --button-background-hover-color: #272727;
            --button-background-active-color: #333333;
        `,
    secondary: emotion_react_browser_esm/* css */.iv`
            --button-text-color: #0f0f0f;
            --button-background-color: rgba(15, 15, 15, 0.05);
            --button-background-hover-color: rgba(15, 15, 15, 0.09);
            --button-background-active-color: rgba(15, 15, 15, 0.15);
        `,
    destructive: emotion_react_browser_esm/* css */.iv`
            --button-text-color: #ffffff;
            --button-background-color: #dd1d1d;
            --button-background-hover-color: #c71a1a;
            --button-background-active-color: #b11717;
        `,
    base: emotion_react_browser_esm/* css */.iv`
            --button-focus-color: #0f0f0f;
            --button-disabled-text-color: rgba(15, 15, 15, 0.2);
            --button-disabled-background-color: rgba(15, 15, 15, 0.05);
        `
  }
}, h = ({ theme: t, variant: c, hideFocus: n, loading: b, fullWidth: e }) => [
  l,
  r[t][c],
  r[t].base,
  !n && i,
  b && g,
  e && d
];


;// CONCATENATED MODULE: ./node_modules/@epidemicsound/design-system/dist/v2/Actions/Button/Button.mjs






const Button_x = (0,react.forwardRef)(
  ({
    type: u = "button",
    variant: n = "primary",
    loading: r,
    disabled: i,
    children: c,
    onClick: e,
    icon: t,
    iconPosition: m = "start",
    fullWidth: l,
    ...s
  }, f) => {
    const { hideFocus: a, ...p } = (0,hooks/* useHideFocusOnClick */.uT)(s), { theme: d } = (0,theme/* useTheme */.Fg)();
    return /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(
      "button",
      {
        type: u,
        ref: f,
        "aria-disabled": i,
        css: h({ variant: n, hideFocus: a, theme: d, loading: r, fullWidth: l }),
        onClick: i || r ? void 0 : e,
        ...s,
        ...p,
        children: [
          r && /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spinner/* Spinner */.$, { size: "1rem", css: x }),
          t && m === "start" && /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(t, { fill: "currentColor" }),
          c,
          t && m === "end" && /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(t, { fill: "currentColor" })
        ]
      }
    );
  }
);
Button_x.displayName = "Button";
function H({
  variant: u = "primary",
  loading: n,
  disabled: r,
  children: i,
  onClick: c,
  icon: e,
  iconPosition: t = "start",
  component: m,
  fullWidth: l,
  ...s
}, f) {
  const { hideFocus: a, ...p } = (0,hooks/* useHideFocusOnClick */.uT)(s), { theme: d } = (0,theme/* useTheme */.Fg)();
  return /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(
    m || "a",
    {
      ref: f,
      "aria-disabled": r,
      css: h({ variant: u, hideFocus: a, theme: d, loading: n, fullWidth: l }),
      onClick: r || n ? (b) => b.preventDefault() : c,
      ...s,
      ...p,
      children: [
        n && /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spinner/* Spinner */.$, { size: "1rem", css: x }),
        e && t === "start" && /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(e, { fill: "currentColor" }),
        i,
        e && t === "end" && /* @__PURE__ */ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(e, { fill: "currentColor" })
      ]
    }
  );
}
const O = (0,react.forwardRef)(H);



/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ })

}]);